/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Cargando"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esMX = Object.assign(TranslationProviderComponent, {
  translations
});

export { esMX as e };
//# sourceMappingURL=es-MX-CfKXkNyk.js.map
